module.exports = __webpack_public_path__ + "static/averta-regularitalic-f57b241b4d3401dd858067fb3a71894e.woff";